import { computed, getCurrentInstance } from "@vue/composition-api";
import { checkAuthorities } from "@scrile/tools/dist/lib/SecurityHelpers";
import useAdditionalProviders from "@/hooks/useAdditionalProviders";
import { MUTATION_TYPES } from "@/store/const";
import { StateRoot } from "@/store/state";
import { ProviderPrefix } from "@/lib/api";

export default function useAdminManagedUser() {
  const vm = getCurrentInstance();
  const { authorities, login, getTokens, closeConnection } = useAdditionalProviders(ProviderPrefix.ADMIN);

  const isAdminManagedUser = computed<StateRoot["isAdminManagedUser"]>(
    () => (vm?.$store.state as StateRoot).isAdminManagedUser
  );

  const init = async () => {
    let isManaged = false;
    try {
      await getTokens();
      await login();
      isManaged = checkAuthorities(authorities.value, ["updateAnyContentSet"]);
    } catch (e) {
    } finally {
      closeConnection();
    }

    vm?.$store.commit(MUTATION_TYPES.SET_ADMIN_MANAGED, isManaged);
  };
  return { isAdminManagedUser, init };
}
